import { IconButton, InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { managerComponentStyles } from '~/modules/covenants/CovenantsDataForm/CovenantsFormByManager/components/styles.ts';

interface IApplicationSearchPanelProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  onSearchSubmit: () => void;
  placeholder?: string;
  searchButtonAriaLabel?: string;
  clearButtonAriaLabel?: string;
  autoComplete?: string;
}

export const SearchPanel = ({
  searchQuery,
  onSearchChange,
  onSearchSubmit,
  placeholder,
  searchButtonAriaLabel,
  clearButtonAriaLabel = 'Очистити пошук',
  autoComplete = 'off',
}: IApplicationSearchPanelProps) => {
  return (
    <TextField
      fullWidth
      variant="outlined"
      placeholder={placeholder}
      autoComplete={autoComplete}
      value={searchQuery}
      onChange={(event) => onSearchChange(event.target.value)}
      onKeyDown={(event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          onSearchSubmit();
        }
      }}
      size="medium"
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <IconButton
                size="small"
                aria-label={searchButtonAriaLabel}
                onClick={onSearchSubmit}
                edge="start"
              >
                <SearchIcon color="action" />
              </IconButton>
            </InputAdornment>
          ),
          endAdornment: searchQuery && (
            <InputAdornment position="end">
              <IconButton
                size="small"
                aria-label={clearButtonAriaLabel}
                onClick={() => onSearchChange('')}
                edge="end"
              >
                <ClearIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ),
          sx: managerComponentStyles.searchInput,
        },
      }}
    />
  );
};
